import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Page from 'src/components/Page';
import { useNavigate } from 'react-router-dom';
import palette from 'src/theme/palette';
import Iconify from 'src/components/Iconify';
import ReactApexChart from 'react-apexcharts';
import { api } from 'src/Api';
import { Link as RouterLink } from 'react-router-dom';
import ProjectTable from 'src/layouts/ProjectComponents/ProjectTable';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { LoadingButton } from '@mui/lab';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import { toast } from 'react-toastify';

export default function ProjectList() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const intervalRef = useRef();

  const [search, setsearch] = useState('');
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const [loading, setloading] = useState(false);
  const [list, setlist] = useState([]);
  const [pagination, setPagination] = useState({});
  const [fileStatus, setFileStatus] = useState({});
  const [permission, setpermission] = useState([]);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successTimer, setSuccessTimer] = useState(5);

  const requirement = [
    'add',
    'upload file',
    'edit',
    'delete',
    'project invite',
    'add sub project',
    'view sub project',
    'user invite'
  ];

  useEffect(() => {
    checkRender();
    getCurrentProcessingFileData();
  }, []);

  // Show modal when status is completed
  useEffect(() => {
    if (fileStatus?.status === 'completed') {
      setShowSuccessModal(true);
      setSuccessTimer(5);
    }
  }, [fileStatus?.status]);

  // Timer countdown and close modal + refresh list
  useEffect(() => {
    if (!showSuccessModal) return;
    if (successTimer === 0) {
      setShowSuccessModal(false);
      getProjectList(1);
      return;
    }
    const timer = setTimeout(() => setSuccessTimer((t) => t - 1), 1000);
    return () => clearTimeout(timer);
  }, [showSuccessModal, successTimer]);

  useEffect(() => {
    if (fileStatus?.status === 'processing') {
      getCurrentProcessingFileData(); // initial call
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          getCurrentProcessingFileData();
        }, 10000);
      }
    } else {
      // status processing se hat gaya, interval clear karo
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [fileStatus?.status]);

  function checkRender() {
    let check = 'projects';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );

    localPerm[0]?.permission_types?.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    if (pagination && Object.keys(pagination).length > 0) {
      list.length = 0;
      getProjectList(pagination.current_page);
    }
  }, [pagination.current_page]);

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getProjectList(1);
    }
  }, [search]);

  function getProjectList(page) {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    search.length > 0 && queryParams.append('search', search);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.get_all_project}?${queryParams.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setlist(result?.data);
        setPagination(result.pagination);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  const refresh = () => {
    setlist([]);
    getProjectList();
  };

  const handlePageChange = (event, newPage) => {
    setPagination((prev) => ({ ...prev, current_page: newPage }));
  };

  function handleFileUpload(e) {
    setUploadFileLoader(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('file', file);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: formData
    };

    fetch(api.import_task, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setFileStatus(result?.data);
          getCurrentProcessingFileData();
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        toast.error(error.error);
        console.log('error', error);
      })
      .finally(() => {
        setUploadFileLoader(false);
      });
  }

  function getCurrentProcessingFileData() {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(api.get_my_current_import, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setFileStatus(result?.data);
        // if (result?.data?.status == 'completed') {
        //   getProjectList(1);
        // }
      })
      .catch((error) => {
        console.log('error', error);
        setFileStatus({});
      })
      .finally(() => {});
  }

  const canAdd = permission.includes('add');
  const canUpload = permission.includes('upload file');

  return (
    <Page title={`Projects | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Typography
        sx={{
          fontSize: 25,
          fontFamily: 'poppinsSemiBold',
          padding: '0 10px 0 10px',
          marginBottom: 2
        }}
      >
        Projects
      </Typography>

      <Box sx={{ mx: 1.5, my: 2 }}>
        <Grid container spacing={1.5} alignItems="center" mb={2}>
          {/* Search Section */}
          <Grid item xs={12} md>
            <Grid container spacing={1.5} alignItems="center">
              {/* Searchbar */}
              <Grid item xs={12} sm={9} md>
                <Searchbar
                  width="100%"
                  value={search}
                  setFunction={(val) => setsearch(val)}
                  placeholder="Search..."
                  onEnter={() => {
                    list.length = 0;
                    getProjectList(1);
                  }}
                />
              </Grid>

              {/* Search Button */}
              <Grid item xs={12} sm={3} md="auto">
                <LoadingButton
                  fullWidth
                  sx={{
                    borderRadius: 0.7,
                    minWidth: 36
                  }}
                  variant="contained"
                  onClick={() => getProjectList(1)}
                >
                  <Iconify icon="material-symbols:search" sx={{ width: 20, height: 20 }} />
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>

          {/* Add Button */}
          {canAdd && (
            <Grid item xs={12} sm="auto">
              <Button
                fullWidth
                variant="contained"
                to="/project/add"
                component={RouterLink}
                disabled={uploadFileLoader}
                startIcon={<Iconify icon="ic:round-plus" sx={{ fontSize: 19, mr: -0.5 }} />}
                sx={{
                  fontSize: 12,
                  color: palette.primary.primary,
                  fontFamily: 'poppinsLight',
                  borderRadius: 0.7,

                  whiteSpace: 'nowrap'
                }}
              >
                Add
              </Button>
            </Grid>
          )}

          {/* Upload File Button */}
          {canUpload && (
            <Grid item xs={12} sm="auto">
              <LoadingButton
                fullWidth
                variant="contained"
                loading={uploadFileLoader}
                disabled={
                  (fileStatus?.status === 'processing' && fileStatus?.type === 'project') ||
                  uploadFileLoader ||
                  fileStatus?.type === 'sub_project' ||
                  loading
                }
                startIcon={
                  <Iconify icon="basil:file-upload-solid" sx={{ fontSize: 19, mr: -0.5 }} />
                }
                sx={{
                  fontSize: 12,
                  color: palette.primary.primary,
                  fontFamily: 'poppinsLight',
                  borderRadius: 0.7,

                  whiteSpace: 'nowrap'
                }}
                component="label"
              >
                Upload File
                <input type="file" hidden accept=".xlsx,.xls,.csv" onChange={handleFileUpload} />
              </LoadingButton>
            </Grid>
          )}
        </Grid>

        {fileStatus?.status == 'processing' && fileStatus?.type == 'project' && (
          <Card
            sx={{
              mb: 3,
              py: 1,
              px: 2,
              borderRadius: 1,
              boxShadow: '1px 2px 13px 0px rgba(0,0,0,0.1)',
              backgroundColor: palette.primary.lighterMain
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  fontFamily: 'poppinsMedium',
                  color: palette.primary.main
                }}
              >
                File Upload Status
              </Typography>

              <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'center' }}>
                {/* <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      color: palette.primary.titledark,
                      mb: 0.5
                    }}
                  >
                    Total Records
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontFamily: 'poppinsBold', color: palette.primary.main }}
                  >
                    {fileStatus?.total_records}
                  </Typography>
                </Box> */}
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      color: palette.primary.titledark,
                      mb: 0.5
                    }}
                  >
                    Processed
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontFamily: 'poppinsBold', color: palette.success.main }}
                  >
                    {fileStatus?.processed_records}
                  </Typography>
                </Box>
                {/* <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: 'poppinsMedium',
                      color: palette.primary.titledark,
                      mb: 0.5
                    }}
                  >
                    Remaining
                  </Typography>
                  <Typography
                    sx={{ fontSize: 13, fontFamily: 'poppinsBold', color: palette.warning.main }}
                  >
                    {uploadingFiles.filter((f) => f.processing).length}
                  </Typography>
                </Box> */}
                <Box sx={{ textAlign: 'center', ml: 4 }}>
                  <Typography
                    sx={{ fontFamily: 'poppinsLight' }}
                    className={
                      (fileStatus?.status?.toLowerCase() == 'complete' && 'status-green') ||
                      (fileStatus?.status?.toLowerCase() == 'processing' && 'status-pending')
                    }
                  >
                    {fileStatus?.status || 'N/A'}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Card>
        )}

        {fileStatus?.type == 'project' && (
          <Dialog open={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
            <DialogTitle
              sx={{
                fontFamily: 'poppinsBold',
                fontSize: 18,
                textAlign: 'center',
                color: palette.primary.main
              }}
            >
              Import Successfull
            </DialogTitle>
            <DialogContent>
              <Typography
                sx={{ fontFamily: 'poppinsMedium', fontSize: 15, mb: 2, textAlign: 'center' }}
              >
                {fileStatus?.processed_records} records imported successfully
              </Typography>
              <Typography sx={{ fontFamily: 'poppinsRegular', fontSize: 13, textAlign: 'center' }}>
                page will refresh in {successTimer} seconds...
              </Typography>
            </DialogContent>
          </Dialog>
        )}

        <ProjectTable
          data={list}
          refresh={refresh}
          loading={loading}
          handlePageChange={handlePageChange}
          pagination={pagination}
          permission={permission}
        />
      </Box>
    </Page>
  );
}
